import {AdminClassroomTable} from './AdminClassroomTable';

export default AdminClassroomTable;
